import {
  BarChart3,
  Building2,
  FileText,
  HelpCircle,
  Info,
  Library,
  Projector,
  Shield,
  Star,
  Tag,
  Users,
  FileTypeIcon,
  LayoutGrid,
} from 'lucide-react';

const mainNavItems = [
  {
    label: 'Library',
    icon: <Library className="w-4 h-4" />,
    to: '/dashboard/library',
  },
  {
    label: 'Favorites',
    icon: <Star className="w-4 h-4" />,
    to: '/dashboard/favorites',
  },
  {
    label: 'Help Guides',
    icon: <FileText className="w-4 h-4" />,
    to: '/dashboard/help-guides',
  },
  {
    label: 'Reports',
    icon: <BarChart3 className="w-4 h-4" />,
    to: '/dashboard/reports',
  },
  {
    label: 'Admin',
    icon: <Shield className="w-4 h-4" />,
    to: '/dashboard/admin',
    subMenu: [
      {
        label: 'Scenarios',
        to: '/dashboard/admin/scenario/manage-scenarios',
        icon: <Projector className="w-3 h-3" />,
      },
      {
        label: 'Global Slides',
        to: '/dashboard/admin/scenario/manage-global-slides',
        icon: <FileTypeIcon className="w-3 h-3" />,
      },
      {
        label: 'Categories',
        to: '/dashboard/admin/scenario/manage-categories',
        icon: <LayoutGrid className="w-3 h-3" />,
      },
      {
        label: 'Tags',
        to: '/dashboard/admin/scenario/manage-tags',
        icon: <Tag className="w-3 h-3" />,
      },
      {
        label: 'Companies',
        to: '/dashboard/admin/companies/manage-companies',
        icon: <Building2 className="w-3 h-3" />,
      },
      {
        label: 'Users',
        to: '/dashboard/admin/users/manage-users',
        icon: <Users className="w-3 h-3" />,
      },
      {
        label: 'Help Guides',
        to: '/dashboard/admin/help-guides/manage-help-guides',
        icon: <Info className="w-3 h-3" />,
      },
      {
        label: 'FAQ',
        to: '/dashboard/admin/faq/manage-faqs',
        icon: <HelpCircle className="w-3 h-3" />,
      },
    ],
  },
];

export default mainNavItems;
